import { Box, Button, Typography } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function DemoSection() {
  return (
    <>
      <Box sx={{ pb: { lg: 10, xs: 5 } }} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Typography
          variant="h4"
          textAlign="center"
          sx={{
            pt: { lg: 10, xs: 0 },
            pb: { lg: 5, xs: 5 },
            fontFamily: "Oswald, Arial",
            fontSize: { lg: "38px", xs: "20px" },
            color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
          }}
        >
          FOR A DEMO AND FREE TRIAL
        </Typography>

        <a href="/contact">
          <Button
            size="large"
            variant="contained"
            color="warning"
            sx={{
              borderRadius: 0.5,
              width: { lg: "350px", sm: "350px", xs: "250px" },
              fontFamily: "oswald",
              "&:hover": {
                backgroundColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
              },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "30px", sm: "20px" },
                fontFamily: "Oswald, Arial",
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              }}
            >
              CONTACT US
            </Typography>
          </Button>
        </a>
      </Box>
    </>
  );
}

export default DemoSection;
